export class WizardDTO {
    public persona: PersonaDataDto;
    public cotizacion: CotizacionDataDto;
    public payment: ContratacionDataDto;
    public consentimientos: ConsentimientosDataDto[];
}


export class PersonaDataDto {
    public fechaNacimiento?: string;
    public telefonoMovil?: Number;
    public nombre?: string;
    public email?: string;
    public apellidos?: string;
    public dni?: string;
    public direccion: string;
    public apellido1: string;
    public apellido2: string;
    public cp: string;
    public municipio: string;
    public telefono: string;
    

}


export class CotizacionDataDto {
    idCotizacion!: number;
    anual!: number;
    codigoError!: number;
    autorizada!: boolean;

}


export class ContratacionDataDto {
    cvv: string;
    expMonth: string;
    expYear: string;
    number: string;    
}

export class ConsentimientosDataDto {
    idConsentimiento: number;
    aceptar: boolean;   
}
